module.exports = __webpack_public_path__ + "img/coareas.bf00a12e.webp";